import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import Utility from "../../../shared/utility";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import BackToTop from "../../common/back-to-top.vue";
import moment from "moment";
import reportService from "./reports-service";
import exportLimit from "../../common/export-limit.vue";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
export default {
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      mainPage: "",
      subPage: "",
      backSlash: true,
      pageUrl: "",
      showAdd: false,
      refresh: true,
      maxStartDate: new Date().toISOString().split("T")[0],
      minEndDate: new Date(new Date().getTime() - 86400000).toISOString().split("T")[0],
      maxEndDate: new Date(new Date().getTime()).toISOString().split("T")[0],
      sDate: "",
      eDate: "",
      startDate: false,
      endDate: false,
      selectedProject: "",
      projectList: [],
      disableAll: true,
      disableSpecific: true,
      selectedBusiness: "",
      businessData: [],
      dateSelected: false,
      runDisabled: true,
      specificDialog: false,
      partClassSearchValid: false,
      page: 1,
      totalPages: 0,
      showBusiness: false,
      completedBTOData: [],
      excelName: "",
      totalRecords: 0,
      exportDisable: true,
      export50kData: false,
      exportDialog: false,
      showData: false,
      showStartDate: true,
      showEndDate: true,
      hideAll: false,
      hideSpecific: false,
      showPartNum: false,
      apiObj: {
        pass: 0,
        user_id: 0,
        lcsdate: "",
        lcedate: "",
        proj_id: 0,
        part_num: "",
        bu_id: 0,
        PageNumber: 0,
        export: 0,
        guid: "",
        SearchValue: "",
        SearchType: "",
      },
      headerBTO: [
        { text: "SO", value: "SO", class: "primary customwhite--text", width: "8%" },
        { text: "BTO", value: "BTO", class: "primary customwhite--text", width: "8%" },
        { text: "Name", value: "Name", class: "primary customwhite--text", width: "8%" },
        { text: "Kit Name", value: "KitName", class: "primary customwhite--text", width: "8%" },
        { text: "Part Number", value: "PartNo", class: "primary customwhite--text", width: "8%" },
        { text: "Customer Id", value: "request_number", class: "primary customwhite--text", width: "8%" },
        { text: "SC Task", value: "reasn_code", class: "primary customwhite--text", width: "8%" },
        { text: "ASSET/BCN", value: "ASSET_BCN", class: "primary customwhite--text", width: "8%" },
        { text: "Serial/ICCID", value: "Serial_ICCID", class: "primary customwhite--text", width: "8%" },
        { text: "Warehouse", value: "Warehouse", class: "primary customwhite--text", width: "8%" },
        { text: "Date Issued", value: "Date_Issued", class: "primary customwhite--text", width: "12%" },
        { text: "Date Completed", value: "Date_Completed", class: "primary customwhite--text", width: "12%" },
        { text: "Date Shipped", value: "Date_Shipped", class: "primary customwhite--text", width: "12%" },
        { text: "DOA", value: "DOA", class: "primary customwhite--text", width: "8%" },
        { text: "Comments", value: "comments", class: "primary customwhite--text", width: "8%" },
      ],
      json_fields: {
        SO: "SO",
        BTO: "BTO",
        Name: "Name",
        "Kit Name": "KitName",
        "Part Number": "PartNo",
        "ASSET/BCN": "ASSET/BCN",
        "Serial/ICCID": "Serial/ICCID",
        IMEI: "IMEI",
        ICCID: "ICCID",
        "LAN Adapter": "LAN Adapter",
        "LAN Wi-Fi Adapter": "LAN Wi-Fi Adapter",
        "BT Adapter": "BT Adapter",
        "Mobile Adapter": "Mobile Adapter",
        Warehouse: "Warehouse",
        "Date Issued": "Date Issued",
        "Date Completed": "Date Completed",
        "Date Shipped": "Date Shipped",
      },
      selectedType: "EQUALS",
      searchString: "",
      typeList: [
        {
          Name: "Equals To",
          Value: "EQUALS",
        },
        {
          Name: "Contains",
          Value: "CONTAINS",
        },
      ],
      max100Rule: [(v) => (v && v.length <= 100) || "Search string must be less than or equal to 100 characters"],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.sDate ? moment(this.sDate).format("MM/DD/YYYY") : moment(new Date().getTime() - 86400000).format("MM/DD/YYYY");
    },
    computedEndDateFormattedMomentjs() {
      return this.eDate ? moment(this.eDate).format("MM/DD/YYYY") : moment(new Date()).format("MM/DD/YYYY");
    },
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.showStartDate = false;
      this.showEndDate = false;
      this.$nextTick(() => {
        this.showStartDate = true;
        this.sDate = null;
        this.showEndDate = true;
        this.eDate = null;
      });
      this.selectedProject = "";
      this.projectList = [];
      this.disableAll = true;
      this.disableSpecific = true;
      this.selectedBusiness = "";
      this.businessData = [];
      this.dateSelected = false;
      this.runDisabled = true;
      this.specificDialog = false;
      this.partClassSearchValid = false;
      this.page = 1;
      this.totalPages = 0;
      this.showBusiness = false;
      this.completedBTOData = [];
      this.excelName = "";
      this.totalRecords = 0;
      this.exportDisable = true;
      this.export50kData = false;
      this.exportDialog = false;
      this.showData = false;
      this.hideAll = false;
      this.hideSpecific = false;
      this.showPartNum = false;
      this.apiObj = {
        pass: 0,
        user_id: 0,
        lcsdate: "",
        lcedate: "",
        proj_id: 0,
        part_num: "",
        bu_id: 0,
        PageNumber: 0,
        export: 0,
        guid: "",
      };
      this.selectedType = "EQUALS";
      this.searchString = "";
    },
    // set end Date
    setEndDate() {
      let minEndDate = new Date(this.sDate);
      this.minEndDate = new Date(minEndDate.getTime() + 0).toISOString().substr(0, 10);
      let maxSDate = new Date(this.maxStartDate);
      this.maxEndDate = new Date(maxSDate.getTime() + 0).toISOString().substr(0, 10);
    },
    //On click continue
    async onContinue() {
      !this.sDate ? (this.sDate = new Date(new Date().getTime() - 86400000).toISOString().substr(0, 10)) : "";
      this.apiObj.lcsdate = Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00");
      this.apiObj.lcedate = Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59");
      this.apiObj.pass = 0;
      this.apiObj.user_id = parseInt(this.userId);
      this.searchString = "";
      this.selectedType = "EQUALS";
      this.$refs.filterSearchForm.resetValidation();
      let showMessage = false;
      let projData = await reportService.completedBTOReport("post", this.apiObj, showMessage);
      if (projData.message !== "NA") {
        this.projectList = projData;
        this.dateSelected = true;
      } else {
        let Alert = {
          type: "error",
          isShow: true,
          message: "No Data Available change the Start Date",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.dateSelected = false;
      }
    },
    //Project Selected
    onChangeProject() {
      this.disableAll = false;
      this.disableSpecific = false;
      this.runDisabled = true;
      this.showBusiness = false;
      this.completedBTOData = [];
      this.totalRecords = 0;
      this.totalPages = 0;
      this.exportDisable = true;
      this.showData = false;
      this.hideAll = false;
      this.hideSpecific = false;
      this.showPartNum = true;
      // this.allPartNumber();
    },
    //All Part Clicked
    async allPartNumber() {
      this.apiObj.lcsdate = Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00");
      this.apiObj.lcedate = Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59");
      this.apiObj.pass = 1;
      this.apiObj.user_id = parseInt(this.userId);
      this.apiObj.proj_id = parseInt(this.selectedProject);
      let showMessage = false;
      let busData = await reportService.completedBTOReport("post", this.apiObj, showMessage);
      if (busData.message !== "NA") {
        this.businessData = busData;
        this.showBusiness = true;
        this.runDisabled = true;
        this.showData = false;
        this.hideAll = false;
        this.hideSpecific = true;
      } else {
        Utility.showNoDataToast("Data is not available for the specified search criteria.");
      }
    },
    //Run Report
    async runReport(page) {
      if (this.searchString != "") {
        this.apiObj.lcsdate = Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00");
        this.apiObj.lcedate = Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59");
        this.apiObj.pass = 4;
        this.apiObj.user_id = parseInt(this.userId);
        this.apiObj.proj_id = 0;
        this.apiObj.bu_id = 0;
        this.apiObj.PageNumber = page;
        this.apiObj.export = 0;
        this.apiObj.SearchValue = this.searchString;
        this.apiObj.SearchType = this.selectedType;
      } else {
        this.apiObj.lcsdate = Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00");
        this.apiObj.lcedate = Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59");
        this.apiObj.pass = 3;
        this.apiObj.user_id = parseInt(this.userId);
        this.apiObj.proj_id = parseInt(this.selectedProject);
        this.apiObj.bu_id = parseInt(this.selectedBusiness);
        this.apiObj.PageNumber = page;
        this.apiObj.export = 0;
        this.apiObj.SearchValue = "";
        this.apiObj.SearchType = "";
      }
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .post("/rt/completed_bto_report_new", this.apiObj)
        .then((response) => {
          if (response.status == 200) {
            let responseData = response.data.body;
            if (responseData?.length !== 0) {
              const newArr = responseData.map((obj) => {
                return {
                  ...obj,
                  Date_Issued: obj["Date_Issued"] ? moment(obj["Date_Issued"]).format("MM/DD/YYYY") : "",
                  Date_Completed: obj["Date_Completed"] ? moment(obj["Date_Completed"]).format("MM/DD/YYYY") : "",
                  Date_Shipped: obj["Date_Shipped"] ? moment(obj["Date_Shipped"]).format("MM/DD/YYYY") : "",
                };
              });
              this.completedBTOData = newArr;
              this.totalRecords = responseData[0].TotalRecords;
              this.exportDisable = false;
              this.totalPages = responseData[0].TotalPages;
              this.showData = true;
            } else {
              this.completedBTOData = [];
              this.totalRecords = 0;
              this.totalPages = 0;
              this.exportDisable = true;
              this.showData = false;
              let Alert = {
                type: "error",
                isShow: true,
                message: "No records based on the selected criteria",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Export Data using component
    async exportData() {
      this.export50kData = true;
      this.exportDialog = false;
    },
    //To export the Excel file
    async exportToExcel() {
      if (this.totalRecords <= 15000) {
        this.startDownload();
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Completed BTO Report");
        const borderStyle = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        const colors = {
          grey: { type: "pattern", pattern: "solid", fgColor: { argb: "D3D3D3" } },
        };
        //Add Header Rows
        worksheet.addRow([
          "SO",
          "BTO",
          "Name",
          "Kit Name",
          "Part Number",
          "ASSET/BCN",
          "Serial/ICCID",
          "IMEI",
          "ICCID",
          "LAN Adapter",
          "LAN Wi-Fi Adapter",
          "BT Adapter",
          "Mobile Adapter",
          "Warehouse",
          "Date Issued",
          "Date Completed",
          "Date Shipped",
          "SC Task ",
          "Request Number",
          "RMA",
          "RITM",
          "DOA",
          "Comments",
        ]);
        // Style configuration
        const headerStyle = {
          font: { bold: true },
          alignment: { horizontal: "center", vertical: "middle" },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          fill: { type: "pattern", pattern: "solid", fgColor: { argb: "D3D3D3" } },
        };
        // Apply styles to the header rows
        worksheet.getRow(1).eachCell((cell) => {
          cell.style = { ...headerStyle, fill: colors.grey };
          cell.border = borderStyle;
        });
        if (this.searchString != "") {
          this.apiObj.lcsdate = Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00");
          this.apiObj.lcedate = Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59");
          this.apiObj.pass = 4;
          this.apiObj.user_id = parseInt(this.userId);
          this.apiObj.proj_id = 0;
          this.apiObj.bu_id = 0;
          this.apiObj.PageNumber = 1;
          this.apiObj.export = 1;
          this.apiObj.SearchValue = this.searchString;
          this.apiObj.SearchType = this.selectedType;
        } else {
          this.apiObj.lcsdate = Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00");
          this.apiObj.lcedate = Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59");
          this.apiObj.pass = 3;
          this.apiObj.user_id = parseInt(this.userId);
          this.apiObj.proj_id = parseInt(this.selectedProject);
          this.apiObj.bu_id = parseInt(this.selectedBusiness);
          this.apiObj.PageNumber = 1;
          this.apiObj.export = 1;
          this.apiObj.SearchValue = "";
          this.apiObj.SearchType = "";
        }
        const response = await this.axios.post("/rt/completed_bto_report_new_export", this.apiObj);
        let responseData = response.data.body;
        const newArr = responseData.map((obj) => {
          return {
            ...obj,
            Date_Issued: obj["Date_Issued"] ? moment(obj["Date_Issued"]).format("MM/DD/YYYY") : "",
            Date_Completed: obj["Date_Completed"] ? moment(obj["Date_Completed"]).format("MM/DD/YYYY") : "",
            Date_Shipped: obj["Date_Shipped"] ? moment(obj["Date_Shipped"]).format("MM/DD/YYYY") : "",
            Serial_ICCID: obj["ICCID"] !== "" ? obj["Serial_ICCID"] : obj["Serial_ICCID"].replace("/", ""),
          };
        });
        this.export50kData = false;
        //Add your data rows
        newArr.forEach((item) => {
          const row = worksheet.addRow([
            item.SO,
            item.BTO,
            item.Name,
            item.KitName,
            item.PartNo,
            item["ASSET_BCN"],
            item["Serial_ICCID"],
            item.IMEI,
            item.ICCID,
            item["LAN_Adapter"],
            item["LAN_WiFi_Adapter"],
            item["BT_Adapter"],
            item["Mobile_Adapter"],
            item.Warehouse,
            item["Date_Issued"],
            item["Date_Completed"],
            item["Date_Shipped"],
            item.reasn_code,
            item.request_number,
            item.rma,
            item.RITM,
            item.DOA,
            item.comments,
          ]);
          row.eachCell({ includeEmpty: true }, (cell) => {
            //Apply borders
            cell.border = borderStyle;
          });
        });
        //Download the Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), Utility.excelNewFileName("Completed_BTO_Report"));
        this.finishDownload();
      } else {
        this.exportDialog = true;
        this.finishDownload();
        return true;
      }
    },
    //Start the Loader when excel process starts
    startDownload() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    //End the Loader when the process is completed
    finishDownload() {
      let LoaderDialog = {
        visible: false,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    //On entering text into search box
    clearParameters() {
      this.showStartDate = false;
      this.showEndDate = false;
      this.$nextTick(() => {
        this.showStartDate = true;
        this.sDate = null;
        this.showEndDate = true;
        this.eDate = null;
      });
      this.selectedProject = "";
      this.projectList = [];
      this.disableAll = true;
      this.disableSpecific = true;
      this.selectedBusiness = "";
      this.businessData = [];
      this.dateSelected = false;
      this.runDisabled = true;
      this.specificDialog = false;
      this.partClassSearchValid = false;
      this.page = 1;
      this.totalPages = 0;
      this.showBusiness = false;
      this.completedBTOData = [];
      this.excelName = "";
      this.totalRecords = 0;
      this.exportDisable = true;
      this.export50kData = false;
      this.exportDialog = false;
      this.showData = false;
      this.hideAll = false;
      this.hideSpecific = false;
      this.showPartNum = false;
      this.apiObj = {
        pass: 0,
        user_id: 0,
        lcsdate: "",
        lcedate: "",
        proj_id: 0,
        part_num: "",
        bu_id: 0,
        PageNumber: 0,
        export: 0,
        guid: "",
      };
    },
    //To add and remove From Fav
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
    BackToTop,
    exportLimit,
  },
};
